module.exports = __webpack_public_path__ + "static/img/2.7cd2c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = 195
// module chunks = 1